import { jsx as _jsx } from "react/jsx-runtime";
import { Button, DialogActions, useMediaQuery, useTheme } from "@mui/material";
import { DeliveryScheduleRemappingText } from "../utils/DSRM-typesAndEnums";
export const DSRM_Actions = ({ onClose }) => {
    // const { cancelRemapping } = useCancelRemapping();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return (_jsx(DialogActions, Object.assign({ style: { display: "flex", flexDirection: "column", paddingBottom: "1.5rem", width: "100%" } }, { children: _jsx(Button, Object.assign({ size: "medium", variant: "outlined", fullWidth: isMobile, onClick: onClose }, { children: DeliveryScheduleRemappingText.CANCEL })) })));
};
